<script>
  import { currentLessonIndex, lessons } from "../scripts/stores.js";
  import LessonContent from "./LessonContent.svelte";

  // got to freeze the value of lessons otherwise it will re-render LessonContent, which causes an accumulation of snapshotListeners.
  const allLessons = $lessons;
  let lessonsDyn;
  $: lessonsDyn = $lessons;

  let currentLesson;
  $: currentLesson = allLessons[$currentLessonIndex];
</script>

<main class="page">
  {#key currentLesson}
    <table>
      <tr>
        {#each lessonsDyn as lesson}
          {#if lesson.isComplete}
            <td class="cell-complete" />
          {:else}
            <td class="cell-incomplete" />
          {/if}
        {/each}
      </tr>
    </table>
    <LessonContent {currentLesson} />
  {/key}
</main>

<style>
  table {
    width: 100%;
    height: 2px;
  }

  .cell-complete {
    background-color: green;
  }

  .cell-incomplete {
    background-color: #fff;
  }
</style>
